// Small pure helpers for the carrier settings page.

// Server messages (422 {message}) come through as Error.message; fall back only when there is none.
export const carrierErrorMessage = (err, fallback) =>
  (err && err.message) || fallback;

// The server decides which providers have a manual delivery adapter; the client keeps no list.
export const canToggleManualDelivery = (carrier) =>
  !!(carrier && carrier.id && carrier.manual_delivery_supported === true);

// Put the row the server saved (it has an id) at the top of the list.
export const prependSavedCarrier = (carriers, saved) => [saved, ...carriers];
